export let sessionToken = localStorage.getItem('m3k-diffusion-session-token');
if (!sessionToken) {
    gotoLogin();
}

export function forgetSession() {
    localStorage.removeItem('m3k-diffusion-session-token');
}

export function gotoLogin() {
    let proto = window.location.protocol;
    let host = window.location.host;
    window.location = `https://auth.ma300k.de/authorize?response_type=code&client_id=Y2ZxZvFsH1fNvLOshJSSIVcZ1Nov5ovQ&scope=openid&redirect_uri=${proto}//${host}/auth-grant.html`;
}
